<script>
    import { FormationsData, BrillianceData } from '../../script/_data'
    import { GetMonsterName } from '../../script/_monster'
    import { ReplaceEnter } from '../../script/_validator'

    export let Info, Memo, Formation, Brilliance, Temperament

    let active = [false, false, false, false]
    let txtBrilliance = ['탄창', '비탄창', '가호', '재능', '강림']

    function onClickActive(_num) {
        active[_num] = !active[_num]
    }

    function onClickInfoDelete(_num) {
        Info[_num] = !Info[_num]
    }
</script>

<div class='info'>
    <div class="inner">
        {#if Info[0]}
            <div class="row">
                <div
                    class="accordion"
                    class:active={active[0]}
                    on:click={() => onClickActive(0)}
                >
                    <p>메모</p>
                    <div class="bar"></div>

                    {#if !active[0]}
                        <p>[펼치기]</p>
                    {:else}
                        <p>[접기]</p>
                    {/if}
                </div>

                {#if active[0]}
                    <div class="detail">
                        <div class="btn">
                            <button on:click={() => onClickInfoDelete(0)}>
                                지우기
                            </button>
                        </div>

                        {@html ReplaceEnter(Memo)}
                    </div>
                {/if}
            </div>
        {/if}

        {#if Info[1]}
            <div class="row">
                <div
                    class="accordion"
                    class:active={active[1]}
                    on:click={() => onClickActive(1)}
                >
                    <p>대형</p>
                    <div class="bar"></div>

                    {#if !active[1]}
                        <p>[펼치기]</p>
                    {:else}
                        <p>[접기]</p>
                    {/if}
                </div>

                {#if active[1]}
                    <div class="detail">
                        <div class="btn">
                            <button on:click={() => onClickInfoDelete(1)}>
                                지우기
                            </button>
                        </div>

                        <div class="formation">
                            {#if Formation.num != -1}
                                <div class="name">
                                    {FormationsData[(Formation.num-1)].name} 대형
                                </div>

                                <ul>
                                    {#each Formation.data as item, i}
                                        <li>{(i+1)}: {GetMonsterName(item)}</li>
                                    {/each}
                                </ul>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
        {/if}

        {#if Info[2]}
            <div class="row">
                <div
                    class="accordion"
                    class:active={active[2]}
                    on:click={() => onClickActive(2)}
                >
                    <p>마신</p>
                    <div class="bar"></div>

                    {#if !active[2]}
                        <p>[펼치기]</p>
                    {:else}
                        <p>[접기]</p>
                    {/if}
                </div>

                {#if active[2]}
                    <div class="detail">
                        <div class="btn">
                            <button on:click={() => onClickInfoDelete(2)}>
                                지우기
                            </button>
                        </div>

                        <div class="brilliance">
                            <ul>
                                {#each txtBrilliance as txt, i}
                                    <li>
                                        {txt} : 
                                        {#if Brilliance[i] > 0}
                                            {BrillianceData[(Brilliance[i]-1)].name}
                                        {:else}
                                            비어있음
                                        {/if}
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                {/if}
            </div>
        {/if}

        {#if Info[3]}
            <div class="row">
                <div
                    class="accordion"
                    class:active={active[3]}
                    on:click={() => onClickActive(3)}
                >
                    <p>추천기질</p>
                    <div class="bar"></div>

                    {#if !active[3]}
                        <p>[펼치기]</p>
                    {:else}
                        <p>[접기]</p>
                    {/if}
                </div>

                {#if active[3]}
                    <div class="detail">
                        <div class="btn">
                            <button on:click={() => onClickInfoDelete(3)}>
                                지우기
                            </button>
                        </div>

                        <div class="temperament">
                            {#if Temperament.length > 0}
                                <ul>
                                    {#each Temperament as item}
                                        <li>{item.name} - {item.temperament}</li>
                                    {/each}
                                </ul>
                            {:else}
                                <div class="name">자유 선택</div>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .info {
        width: calc(35% - 46px - 15px - 6px);
        height: fit-content;
        margin-top: 30px;
        margin-right: 15px;
        padding: 24px 23px;
        border: 3px solid $cl3;

        vertical-align: top;

        .inner {
            background: rgba($color: $cl3, $alpha: 0.3);
            width: calc(100% - 26px);
            padding: 25px 13px;
        }

        .row {
            width: 100%;
            height: fit-content;
            margin: 15px 0px;

            /* 아코디언 선 긋기*/
            .accordion {
                width: 100%;
                height: fit-content;
                display: flex;
                cursor: pointer;

                p {
                    margin: 0;
                    color: $cl2;
                    font-size: 20px;
                    font-family: aggro;
                }

                .bar {
                    content: "";
                    background: $cl2;
                    height: 2px;
                    margin: auto 10px;
                    border: none;
                    flex: auto;
                    vertical-align: middle;
                }

                &:hover {
                    p { color: $cl6; }
                    .bar { background: $cl6; }
                }

                &.active {
                    p { color: $cl3; }
                    .bar { background: $cl3; }
                }
            }

            .detail {
                width: calc(100% - 20px);
                height: fit-content;
                padding: 10px;
                color: $cl2;
                font-size: 14px;
                word-break:break-all;

                .btn {
                    width: 100%;
                    text-align: right;
                }
            }
        }

        .formation, .brilliance, .temperament {
            .name {
                margin-bottom: 10px;
                color: $cl4;
                font-size: 18px;
                font-family: aggro;
            }
            ul {
                margin: 0px;
                padding: 0px;
                list-style: none;

                li { margin: 5px 0px; }
            }
        }

        
        @include mobile { width: calc(100% - 46px - 15px - 6px); }
        @include tablet { width: calc(100% - 46px - 15px - 6px); }
        @include desktop { display: inline-block; }
        @include wide { display: inline-block; }
    }
</style>